import { cn } from '@bw/core';
import { Image } from '@bw/elements';
import { Block } from '../../factories/types';
import { schemeToClass } from '../../utils/colorMap';
import { defined } from '../../utils/defined';
import styles from './ComparisonTable.module.scss';

// TODO(khaney): make this grid-based

export const ComparisonTable: Block<'comparisonTable'> = ({
	data: {
		fields: { title, colorScheme, comparisonPoints, columns },
	},
	render,
	fieldId,
}) => {
	return (
		<section
			className={cn(styles.comparisonTable, schemeToClass(colorScheme))}
			{...fieldId('.')}
		>
			{/* {title ? (
				<div className={styles.title}>
					<span>{title}</span>
				</div>
			) : null} */}
			<ul>
				<li className={styles.titleColumn} {...fieldId('comparisonPoints')}>
					<div className={styles.head}>
						<Image
							src={
								'https://images.ctfassets.net/bn78uo9dn8bo/5sPhVRjNHa2BDzoV2DK4SL/ddf2aa3ae040384792074f4ccfffabf3/icon-logo.svg'
							}
							alt=""
							width={53}
							height={41}
							data-aos="fade-up"
						/>
						<h2 className={styles.title} data-aos="fade-up">
							{title}
						</h2>
					</div>
					{defined(comparisonPoints).map((comparisonPoint, index) => (
						<div key={index} className={styles.row}>
							{render(comparisonPoint, { 'data-aos': 'fade-up' })}
						</div>
					))}
				</li>
				{render(columns, { comparisonPoints })}
			</ul>
		</section>
	);
};
